export function setUser (state, data) {
  if (data) {
    localStorage.setItem('user', JSON.stringify(data));
    localStorage.setItem('authorities', JSON.stringify(data.authorities))

    state.user = { ...data }

  } else {
    localStorage.removeItem('user');
    localStorage.removeItem('authorities')
    state.user = null
  }

}

export function setToken (state, data) {
  if (data) {
    state.token = data.token
    localStorage.setItem('token', state.token);
  } else {
    localStorage.removeItem('token');
    state.token = null
  }
}

export function setTokenD4HToken (state, data) {
  if (data) {
    state.d4HToken = data.d4HToken
    localStorage.setItem('d4HToken', state.d4HToken);
  } else {
    localStorage.removeItem('d4HToken');
    state.d4HToken = null
  }
}


export function initialiseStore (state) {

  if (localStorage.getItem('token')) {
    setToken(state, {
      token: localStorage.getItem('token')
    })
  }

  if (localStorage.getItem('d4HToken')) {
    setTokenD4HToken(state, {
      d4HToken: localStorage.getItem('d4HToken')
    })
  }

  if (localStorage.getItem('user')) {
    setUser(state, JSON.parse(localStorage.getItem('user')))
  }

}
